export default {
  props: {
    leftFixed: Boolean,
    rightFixed: Boolean
  },
  computed: {
    shouldRenderSelection () {
      return !this.rightFixed && this.selection
    }
  }
}



// WEBPACK FOOTER //
// ./src/_utilities/vue2-datatable/_mixins/shouldRenderSelection.js